import AgentCard from '@global/AgentCard'
import { Col, Row } from '@styles/global.styled'
import { Router } from '@routes'

const AgentCardGrid = ({ agents }) => {
  if (!agents?.length) return null

  const onClickEnquire = (agent) => {
    Router.pushRoute('agentListEnquiry', {
      agentSlug: agent.slug,
    })
  }

  return (
    <Row gutter={15}>
      {agents.map((agent, i) => (
        <Col md={4} key={`agent-${i}`}>
          <AgentCard
            {...AgentCard.ApiDataToProps(agent)}
            isLazyLoad={i < 3 ? false : true}
            onClickEnquire={onClickEnquire}
          />
        </Col>
      ))}
    </Row>
  )
}

AgentCardGrid.defaultProps = {
  agents: [],
}

export default AgentCardGrid
